import { effect, Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Binder, BinderSmall } from 'src/app/models/binder.model';
import { BinderDialogService } from './binder-dialog.service';
import { BinderService } from '../api/binder.service';
import { UserAccessService } from './user-access.service';
import { AppAuthService } from './auth.service';
import { AccessPermission } from '@/models/access-permission';
import { DialogType } from '@/models/dialog-mode.model';

@Injectable({
  providedIn: 'root'
})
export class LandmarkBinderMenuService {
  binderMenu = signal<MenuItem[]>([]);
  commandTrigger = signal<any>(null);

  constructor(
    private binderDialogService: BinderDialogService,
    private userAccessService: UserAccessService,
    private currentBinderService: BinderService,
    private appAuthService: AppAuthService,
  ) {
    effect(() => {
      const perms = this.appAuthService.userPerms();
      if(perms) {
      this.populateMenu(perms,this.currentBinderService.currentBinder());
      }
    });
  }

  populateMenu(perms:AccessPermission[], binder:Binder) {
    function checkPerms(permType:string,table:string) {
      const permission = perms.some(perm => perm.dataTable === table && perm.permType === permType && (perm.FID === binder.SelectedFID || perm.FID === null));
      return permission
    }

    // console.log('projectStatus', binder);
    const menu = [
      {
        label: 'File',
        icon: 'pi pi-fw pi-file',
        items: [
          {
            label: 'Generate PDF',
            icon: 'pi pi-fw pi-file-pdf',
            disabled: !(checkPerms('edit','Binders') && this.currentBinderService.apiEditAccess()),
            command: () => this.toggleDrawer('docs', binder.ClientLastName + ' Files')
          },
          {
            separator: true
          },
          {
            label: 'Share',
            icon: 'pi pi-fw pi-share-alt',
            command: () => this.toggleDialog('Share Binder', 'share',true)
          },
          {
            separator: true
          },
          {
            label: 'Export',
            icon: 'pi pi-fw pi-file-export',
            items: [
              {
                label: 'Notes',
                icon: 'pi pi-fw pi-list'
              },
              {
                label: 'Assemblies',
                icon: 'pi pi-fw pi-list'
              }
            ]
          }
        ]
      },

      {
        label: 'View',
        icon: 'pi pi-fw pi-eye',
        items: [
          // {
          //   label: 'Notes',
          //   icon: 'pi pi-fw pi-list',
          //   command: () => this.toggleNotes()
          // },
          // {
          //   label: 'Files',
          //   icon: 'pi pi-fw pi-file',
          //   command: () => this.toggleDrawer('docs', binder.ClientLastName + ' Files')
          // },
          {
            label: 'Drafting Details',
            icon: 'pi pi-fw pi-file-edit',
            disabled: !(checkPerms('draft','Binders') && this.currentBinderService.apiEditAccess()),
            command: () => this.toggleDialog('Drafting Details', 'drafting')
          }

        ]
      },
      {
        label: 'Request',
        icon: 'pi pi-fw pi-bars',
        items: [
          {
            label: 'Approval',
            icon: 'pi pi-fw pi-thumbs-up',
            disabled: !(checkPerms('edit','Binders') && this.currentBinderService.apiEditAccess()),
            command: () => this.toggleDialog('Approval Request', 'approval')
          },
          {
            label: 'Contract Excemption',
            icon: 'pi pi-fw pi-exclamation-circle',
            disabled: !(checkPerms('edit','Binders') && this.currentBinderService.apiEditAccess()),
            command: () => this.toggleDialog('Contract Exemption Request', 'exRequest')
          },
          {
            label: 'Signatures',
            icon: 'pi pi-fw pi-file-pdf',
            disabled: !(checkPerms('request','Binders') || binder.ProjectStatus > 5 || checkPerms('edit','approvalResponses'))  || binder.ES_Hash !== null,
            command: () => this.toggleDialog('Signature Request', 'signatures')
          }
        ]
      },
      {
        label: 'Dev Tools',
        icon: 'pi pi-fw pi-wrench',
        visible: this.appAuthService.userData()?.isDev ?? false,
        items: [
          {
            label: 'Reset Sign Status',
            icon: 'pi pi-fw pi-file-pdf',
            command: () => this.resetSignStatus()
          },
          {
            label: 'Set to Approved',
            icon: 'pi pi-fw pi-file-pdf',
            command: () => this.setToApproved()
          },
          {
            separator: true
          }
        ]
      },
    ]
    this.binderMenu.set(menu);
  }

  public setupEsLink(esHash:string) {
    let menuItems = this.binderMenu();
    let viewMenuItem = menuItems.find(item => item.label === 'View');
    if (viewMenuItem && viewMenuItem.items) {
        viewMenuItem.items.push({
            label: 'Xodo Sign',
            icon: 'pi pi-fw pi-file',
            url: 'https://lexarhomes.eversign.com/documents/' + esHash
        });
    }
  }

  public setupSpLink(spLink:string) {
    let menuItems = this.binderMenu();
    let viewMenuItem = menuItems.find(item => item.label === 'View');
    if (viewMenuItem && viewMenuItem.items) {
        viewMenuItem.items.push({
          label: 'Sharepoint',
          icon: 'pi pi-folder',
          url: spLink
        });
    }
  }

  triggerCommand(command:string) {
    this.commandTrigger.set(command);
  }

  toggleDrawer(type: DialogType, header: string) {
    this.binderDialogService.toggleDrawer(type, header, true);
  }

  toggleDialog(header: string, type: DialogType,noWidth?:boolean) {
    this.binderDialogService.toggleDialog(header, type, true,'cetner',noWidth);
  }

  resetSignStatus() {
    this.updateBinder( {ProjectStatus: 3, ES_Hash: null})
  }

  setToApproved() {
    this.updateBinder({ProjectStatus: 7})
  }

  updateBinder(binderData:Partial<BinderSmall>) {
    const binderId = this.currentBinderService.currentBinder().BinderID
    console.log('patching');
    this.currentBinderService.updateBinder(binderId, binderData).subscribe({
      next: (updatedBinder: Binder) => {
        this.currentBinderService.patchBinder(updatedBinder);
      },
      error: (error) => {
        console.error('Error updating binder:', error);
      }
    }
    );

  }
}
